import React from "react";
import PropTypes from "prop-types";
import './DeletePopup.css'

const DeletePopup = ({
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  contentName,
  contentType,
  popupType,
  deleteable,
  warning
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <h3>{title} </h3>
        {deleteable ? (<p>{message} <span className="name">{contentName}</span> {contentType} ?</p>) : (<p>The <span className="name">{contentName}</span> {warning}</p>)}
        <div className="popup-actions">
          <button className="cancel-btn" onClick={onCancel}>
            {cancelText}
          </button>
          {popupType == 'action' && deleteable &&<button className="confirm-btn" onClick={onConfirm}>
            {confirmText}
          </button>}
        </div>
      </div>
    </div>
  );
};

DeletePopup.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  warning: PropTypes.string,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  deleteable: PropTypes.bool.isRequired,
};

export default DeletePopup;
